(function () {
    'use strict';

    angular
        .module('core.services')
        .service('ModuleService', ModuleService)

    /** @ngInject */
    function ModuleService(HttpService) {
        const ModuleService = {
            getAll
        }

        return ModuleService;

        function getAll() {
            return HttpService.get(`/modules`);
        }
    }
}());